// Leave Type API functions
import { getData, deleteData, postData, putData } from '../apiClient';

// Get leave types with pagination and search
export const getLeaveTypesWithPagination = async (params) => {
    try {
        const { page = 1, limit = 10, search = '', signal = null } = params;

        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const url = `/leave-type/?${queryParams}`;

        const response = await getData(url, {}, {}, signal);
        return {
            success: true,
            ...response
        };
    } catch (error) {
        console.error('Get leave types API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

// Get single leave type by ID
export const getLeaveTypeById = async (id) => {
    try {
        const result = await getData(`/leave-type/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get leave type by ID API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};

// Create new leave type
export const createLeaveType = async ({ data }) => {
    try {
        const result = await postData("/leave-type/", data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Create leave type API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// Update leave type
export const updateLeaveType = async ({ id, data }) => {
    try {
        const result = await putData(`/leave-type/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error('Update leave type API error:', error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// Delete leave type
export const deleteLeaveType = async ({ id }) => {
    try {
        const result = await deleteData(`/leave-type/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Delete leave type API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};
